import Barba from 'barba.js';
import BjzmBarbaTransition from './bjzm-barba-transition.js';

import RegisterForm from '../register-form';
import HomeScroller from '../home-scroller';
import HomeSlider from '../home-slider';

import BjzmScripts from '../bjzm-scripts';
import HeaderScroll from '../header-scroll';
import ImageSlide from '../image-slide';
import SiteSearch from '../site-search';

// import ua from 'universal-analytics';

class BjzmBarba {

	constructor() {

    	this.barbaTransition = new BjzmBarbaTransition();   // handles the page transitions 
    	this.handleAll(null);
    	this.barbaPageEvents();
        this.currentPage = '';
        $(document).trigger("custom-event");
        BjzmScripts.do_hamburger();
    }

    barbaPageEvents() {
    	
    	var self = this;
    	
    	Barba.Dispatcher.on('transitionCompleted', function(currentStatus, oldStatus, container) {
    		self.handleAll(currentStatus);
            $(".barba-animation-wrapper").removeClass(`namespace-${oldStatus.namespace}`);
            $(".barba-animation-wrapper").addClass(`namespace-${currentStatus.namespace}`);
            gtag('config', 'UA-114937327-1', {
              'page_path': location.pathname
            });
            console.log('transitionCompleted');            
    	});

    	Barba.Dispatcher.on('linkClicked', function(HTMLElement, MouseEvent) {
    		var itemPageId = $(HTMLElement).data('page-id');
            self.currentPage = $(HTMLElement).data('post_title');
            $("body").removeClass("navigation--active");
    		$("nav.navigation .navigation__item").removeClass('current-menu-item current_page_item');
    		$(`nav.navigation .navigation__link[data-page-id="${itemPageId}"]`).parent().addClass('current-menu-item');
    	});

        Barba.Dispatcher.on('newPageReady', function(currentStatus, prevStatus, HTMLElementContainer, newPageRawHTML) {
            const newDoc = $(parseHTML(newPageRawHTML));
            const newPageHeader = newDoc.find('#headers');
            if (newPageHeader.length) {
                $('#headers').html(newPageHeader.html());
            }
        });

        function parseHTML(html) {
            var parser = new DOMParser();
            return parser.parseFromString(html, 'text/html');
        }
    }

    handleAll(currentStatus) {
    	document.body.scrollTop = document.documentElement.scrollTop = 0;
    	var HidingHeader = new HeaderScroll(currentStatus);

        var Register = new RegisterForm(currentStatus);

    	BjzmScripts.doAllScripts();

    	var ImageSlider = new ImageSlide();
    	var Scroller = new HomeScroller();
        var Search = new SiteSearch();

        if(this.currentPage == 'Portfolio' ) {
            $(".menu-item-419 a").addClass('no-barba');
            setTimeout(function(){
                $('html, body').scrollTop($('#portfolio-section').offset().top );
                window.location.hash = "portfolio";
            }, 400);
        }
        else {
            $(".menu-item-419 a").removeClass('no-barba');
        }

        $(".menu-item-419 a").on('click', function(e){
            if( $('#portfolio-section').length > 0 ) {
                e.preventDefault();
                window.location.hash = "portfolio";
                $('html, body').animate({ scrollTop: $('#portfolio-section').offset().top}, 400 );
            } 
        });

        var waitTime = ( !currentStatus )  ? 4000 : 0;
		var HomePillarSlider = new HomeSlider({
			waitTime: waitTime
		});

        $('.home-gallery__controls__control').on('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            if (!$(this).hasClass('disabled')) {
                const dir = $(this).hasClass('home-gallery__controls__control--left') ? -1 : 1;
                const prop = $(this).closest('.home-gallery__property');
                const slides = prop.find('.home-gallery__image-outer img');
                const currSlide = prop.data('slide');
                let newSlide = currSlide + dir;
                if (newSlide < 0) {
                    newSlide = slides.length - 1;
                }
                if (newSlide > slides.length - 1) {
                    newSlide = 0;
                }
                if (newSlide > 0) {
                    prop.find('.home-gallery__controls__control--left').removeClass('disabled');
                } else {
                    prop.find('.home-gallery__controls__control--left').addClass('disabled');
                }
                if (newSlide == slides.length - 1) {
                    prop.find('.home-gallery__controls__control--right').addClass('disabled');
                } else {
                    prop.find('.home-gallery__controls__control--right').removeClass('disabled');
                }
                // slides.css('left','-'+newSlide+'00%');
                slides.eq(newSlide).css('left','0').nextAll().css('left','100%');
                prop.data('slide',newSlide);
                slides.removeClass('active').eq(newSlide).addClass('active');
            }
        });
    }


}






module.exports = BjzmBarba;



